// $(document).ready(function(){
  (function(){
    window.CROWDSOURCING = (function(){
      function CROWDSOURCING (){}
      CROWDSOURCING.loadjQuery = function(afterLoad)
      {
        return CROWDSOURCING.loadScript("//ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js",function()
        {
          CROWDSOURCING.$ = jQuery.noConflict(true);
          CROWDSOURCING.loadLink(CROWDSOURCING.api_url+"css/crowdsourcing.css");
          CROWDSOURCING.loadLink(CROWDSOURCING.api_url+"css/bootstrap-grid-only-css.css");
          return afterLoad();
        });
      };
      CROWDSOURCING.loadLink = function(url)
      {
        var style;
        style = document.createElement("link");
        style.type = "text/css";
        style.rel = "stylesheet";
  
        style.href = url;
        return document.getElementsByTagName("head")[0].appendChild(style);
  
      }
      CROWDSOURCING.loadScript  = function(url,callback)
      {
        var script;
        script = document.createElement("script");
        script.type = "text/javascript";
  
        if(script.readyState) {
          script.onreadystatechange = function()
          {
            if(script.readyState == "loaded" || script.readyState == "complete")
            {
              script.onreadystatechange = null;
              return callback();
            }
          };
        }
        else {
          script.onload = function()
          {
            return callback();
          };
        }
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
        return true;
      };
      return CROWDSOURCING;
    })();
  
  
    CROWDSOURCING.api_url = "https://apps-sp.webkul.com/shopify-crowdfunding/";
    CROWDSOURCING.shop_name = Shopify.shop;
    CROWDSOURCING.currency = Shopify.money_format;
    CROWDSOURCING.loadjQuery(function(){
      // console.log(CROWDSOURCING.currency);
  
      // var products_id = '';
      // $(".wk_crowdsourcing_funding").each(function(){
      //   var products = $(this).attr("product_id");
      //   products_id += products+',';
      // })
      // console.log(products_id);
      // $(".wk_crowdsourcing_funding").each(function(){
      //   $(".wk_crowdsourcing_funding").html("PRODUCT FOR DONATE");
      // });
  
  
      function trim (str) {
        return str.replace(/^\s+|\s+$/gm,'');
      }
  
      function rgbaToHex (rgba) {
        var parts = rgba.substring(rgba.indexOf("(")).split(","),
        r = parseInt(trim(parts[0].substring(1)), 10),
        g = parseInt(trim(parts[1]), 10),
        b = parseInt(trim(parts[2]), 10),
        a = parseFloat(trim(parts[3].substring(0, parts[3].length - 1))).toFixed(2);
        return ('#' + r.toString(16) + g.toString(16) + b.toString(16) + (a * 255).toString(16).substring(0,2));
      }
  
      function rgb2hex(rgb){
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4) ? "#" +
        ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
  
        ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
  
        ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
  
      }
  
  
      if($(".wk_crowdfunding_bar").length > 0) {  /*THIS IS FOR ALL PRODUCT ON PRODUCT GRID  */
        products_ids = [];
        $(".wk_crowdfunding_bar").each(function(){
          var product_id = $(this).attr('product_id');
          if(product_id) {
            products_ids.push(product_id);
          }
        });
        if(products_ids) {
          $.ajax({
            type:'POST',
            url : CROWDSOURCING.api_url+"/admin/Crowdsourcing",
            jsonpCallback :"COLLECTION_BAR",
            dataType: "jsonp",
            crossDomain: true,
            data:{shop_name:CROWDSOURCING.shop_name,products_ids:products_ids},
            success:function(response){
              console.log(response);
              if(response) {
                $(".wk_crowdfunding_bar").each(function(){
                  var product_id = $(this).attr('product_id');
                  var same = $(this);
                  $(response.data).each(function(index,value){
                    $(value).each(function(){
                      if(value.product_id == product_id) {
                        // console.log(value.templates);
                        $(same).html(value.templates);
                      }
                    });
                  });
                });
              }
            },
            error:function(response){
              console.log("something went wrong");
            }
          });
        }
      }
  
      
  
      if($("#wk_crowdsourcing").length > 0)
      {
        var product_id= $("#wk_crowdsourcing").attr("product_id");
        var product_type = $("#wk_crowdsourcing").attr("product_type");
        var product_tags = $("#wk_crowdsourcing").attr("product_tags");
  
       
        // localStorage.setItem('customer_email', email_id);
        // localStorage.setItem('customer_id', id);
        if((product_type == "wk_project") || (product_tags.indexOf('wk_project') != -1))
        {
          console.log(product_id);
          console.log(product_type);
          $.ajax({
            type:'POST',
            url : CROWDSOURCING.api_url+"admin/Crowdsourcing",
            jsonpCallback :"crowdsourcing",
            dataType: "jsonp",
            crossDomain: true,
            data:{main_id_product:product_id,shop_name:CROWDSOURCING.shop_name},
            success:function(response){
              console.log(response);
              if(response == 0) {
                $("#wk_crowdsourcing").html("<p class='not_publish'>Product Not Published</p>");
              }
              else {
                var  crowdsourcing = response.crowdsourcing;
                var crowdsourcing_story =response.crowdsourcing_story;
                // console.log(crowdsourcing);
                // console.log(crowdsourcing_story);
                $("#wk_crowdsourcing").html(crowdsourcing);
                $("#wk_crowdsourcing_story").html(crowdsourcing_story);
  
                var target_amount = $(".hidden_traget_amount").val();
                var total_donation = $(".hidden_total_donation").val();
                var rest_donation = target_amount - total_donation;
                var total_donation_percentage = (total_donation*100)/target_amount;
                if(total_donation_percentage < 100) {
                  var rest_donation_percentage = 100 - total_donation_percentage;
                  rest_donation_percentage = parseFloat(rest_donation_percentage.toFixed(2));
                }else{
                  rest_donation_percentage = 0;
                }
                total_donation_percentage = parseFloat(total_donation_percentage.toFixed(2));
  
                var donated_amount_label = $("#wk_donated_amount").text();
                var rest_amount_to_donate_label = $("#wk_rest_amount_to_donate").val();
                var pie_chart_title_label = $(".pie_chart_title_label").val();
                var wk_donated_amount_color = $(".wk_donated_amount_color").text();
                wk_donated_amount_color = rgb2hex(wk_donated_amount_color);
                // wk_donated_amount_color = trim(wk_donated_amount_color);
                // wk_donated_amount_color = wk_donated_amount_color.substring(0,wk_donated_amount_color.length - 2);
                var wk_rest_donation_amount_color = $(".wk_rest_donation_amount_color").text();
                wk_rest_donation_amount_color = rgb2hex(wk_rest_donation_amount_color);
                // wk_rest_donation_amount_color = trim(wk_rest_donation_amount_color);
                // wk_rest_donation_amount_color = wk_rest_donation_amount_color.substring(0,wk_rest_donation_amount_color.length - 2);
  
                if(typeof google != 'undefined') {
                  $("#wk_piechart").css({'height':'400px','width':'600px'});
  
                  google.charts.load('current', {'packages':['corechart']});
                  google.charts.setOnLoadCallback(drawChart);
                  function drawChart() {
                    var data = google.visualization.arrayToDataTable([
                      ['Task', 'Hours per Day'],
                      [donated_amount_label,  {v: total_donation_percentage, f: total_donation_percentage+'%'}],
                      [rest_amount_to_donate_label,   {v: rest_donation_percentage, f: rest_donation_percentage+'%'}]
                    ]);
  
                    var options = {
                      title: ' ',
                      colors: [wk_donated_amount_color, wk_rest_donation_amount_color],
                      legend: {position: 'bottom',alignment: 'end',maxLines: 2,textStyle: {fontSize : '5px'}},
                      chartArea:{left:20,top:20,width:'40%',height:'75%'},
                      pieSliceText: 'value'
                    };
  
                    if(document.getElementById('wk_piechart')) {
                      var chart = new google.visualization.PieChart(document.getElementById('wk_piechart'));
                      chart.draw(data, options);
                    }
                  }
                }
              }
            },
            error:function(response){
              console.log("something went wrong");
            }
          });
        }
      }
  
  
  
      if($("#wk_crowdsourcing_comments").length > 0)
      {
        var product_id= $("#wk_crowdsourcing").attr("product_id");
        var product_type = $("#wk_crowdsourcing").attr("product_type");
        var product_tags = $("#wk_crowdsourcing").attr("product_tags");
        if((product_type == "wk_project") || (product_tags.indexOf('wk_project') != -1))
        {
          $.ajax({
            type:'POST',
            url : CROWDSOURCING.api_url+"admin/Crowdsourcing",
            // jsonpCallback :"comments",     comment this coz want all the cmt here only
            jsonpCallback :"all_comments_page",
            dataType: "jsonp",
            crossDomain: true,
            data:{main_id_product:product_id,shop_name:CROWDSOURCING.shop_name},
            success:function(response){
              // console.log(response);
              if(response == 0) {
                $("#wk_crowdsourcing_comments").html("");
              }
              else {
                $("#wk_crowdsourcing_comments").html(response);
              }
            },
            error:function(response){
              console.log("something went wrong");
            }
          });
        }
      }


      if($(".wk_crowdsourcing_comments").length > 0)
      {
        var product_id= $("#wk_crowdsourcing").attr("product_id");
        var product_type = $("#wk_crowdsourcing").attr("product_type");
        var product_tags = $("#wk_crowdsourcing").attr("product_tags");
        if((product_type == "wk_project") || (product_tags.indexOf('wk_project') != -1))
        {
          $.ajax({
            type:'POST',
            url : CROWDSOURCING.api_url+"admin/Crowdsourcing",
            // jsonpCallback :"comments",     comment this coz want all the cmt here only
            jsonpCallback :"all_comments_page",
            dataType: "jsonp",
            crossDomain: true,
            data:{main_id_product:product_id,shop_name:CROWDSOURCING.shop_name},
            success:function(response){
              // console.log(response);
              if(response == 0) {
                $(".wk_crowdsourcing_comments").html("");
              }
              else {
                $(".wk_crowdsourcing_comments").html(response);
              }
            },
            error:function(response){
              console.log("something went wrong");
            }
          });
        }
      }


  
    });
  
    if($("#wk_comment_page").length > 0)
    {
  
      $.urlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        return results[1] || 0;
      }
      var product_id = $.urlParam('id');
  
      if(product_id)
      {
        $.ajax({
          type:'POST',
          url : CROWDSOURCING.api_url+"admin/Crowdsourcing",
          jsonpCallback :"all_comments_page",
          dataType: "jsonp",
          crossDomain: true,
          data:{main_id_product:product_id,shop_name:CROWDSOURCING.shop_name},
          success:function(response){
            // console.log(response);
            if(response == 0) {
              $("#wk_comment_page").html("");
            }
            else {
              $("#wk_comment_page").html(response);
            }
          },
          error:function(response){
            console.log("something went wrong");
          }
        });
      }
    }
  
    if($("#wk_bidding_detail").length > 0) {
      var customer_id = $("#wk_bidding_detail").attr("customer_id");
      // alert(customer_id);
      getBiddingDetail(1,customer_id,0,1,'bidding_customer');
    }
    $("#wk_bidding_detail").on('click','.winning_auction',function(){
      var customer_id = $("#wk_bidding_detail").attr("customer_id");
      getBiddingDetail(0,customer_id,0,1,'winning_customer');
    });
    $("#wk_bidding_detail").on('click','.all_bids',function(){
      var customer_id = $("#wk_bidding_detail").attr("customer_id");
      getBiddingDetail(1,customer_id,0,1,'bidding_customer');
    });
  
    $("#wk_bidding_detail").on('click','.bidding_filter',function(){
      var customer_id = $("#wk_bidding_detail").attr("customer_id");
      var search_project_title = $(".bidding_search_ptitle").val();
      var search_option_title = $(".bidding_search_option_name").val();
      var search_status = $(".bidding_search_status").val();
  
      if($(".bidding_search_poption").length > 0) {
        var bidding_search_poption = $(".bidding_search_poption").val();
        var bidding_search_amount = $(".bidding_search_amount").val();
        getBiddingDetail(0,customer_id,0,1,'SearchWinningOption',search_project_title,bidding_search_poption,search_status,bidding_search_amount);
      }else{
        getBiddingDetail(1,customer_id,0,1,'search_bidding_customer',search_project_title,search_option_title,search_status);
      }
  
      $(this).siblings("span").css({ 'border-bottom':'none'});
    });
  
    $("#wk_bidding_detail").on('click','.bidding_reset',function(){
      location.reload();
    });
  
  
    if($("#wk_view_crowdfunding").length > 0){
      var email_id= $("#wk_view_crowdfunding").attr("customer_email");
      var id = $("#wk_view_crowdfunding").attr("customer_id");
      $("#wk_view_crowdfunding").html("<a href ='pages/bidding-detail' style=' color:#ffffff !important;'><button type='button' class='view_warranty btn' style='background-color:#f48042;'>View Bidding</button></a>");
      localStorage.setItem('customer_email', email_id);
      localStorage.setItem('customer_id', id);
    }
  
  
  
  
  
    $("#wk_crowdsourcing_story").on('click','.wk_read_more',function(){
      var value = $(".story").text();
      $(".story_textarea").html(value);
    });
  
    $("#wk_crowdsourcing_story").on('click','.wk_read_description_more',function(){
      var val_des = $(".description_text").text();
      // console.log(val_des);
      $(".short_des").html(val_des);
    });
  
  
  
    // $("body").on('click','.wk_read_more_rewards',function(){
    $('#wk_crowdsourcing_story').on('click','.wk_read_more_rewards', function(){
      $("body").find(".wk-read-more-container").html('<div class="wk-popup-main"><div class="wk-popup"><div class="wk-close-popup wk-popup-close" data-dismiss="cs-error" ><img src="'+CROWDSOURCING.api_url+'image/icon-close.png"></div><div class="wk-popup-title"></div><div class="wk-popup-description"></div><div class="wk-popup-cancel"><div class="wk-pop_cancel_btn wk-close-popup">CANCEL</div></div></div>').show();
  
      var more_title = $(this).parents('.wk_description').siblings(".wk_title").children('.more_read_title').text();
      var more_description = $(this).parents('.wk_description').children('.more_reward_text').text();
      $(".wk-popup-title").append(more_title);
      $(".wk-popup-description").html(more_description);
  
  
      var position = $(this).position();
      var distance = parseInt(position.top);
      $("body").find(".wk-read-more-container").find('.wk-popup').css({'top':distance});
      $('html, body').animate({scrollTop: $("body").find(".wk-read-more-container").find('.wk-popup').top -100 }, 'slow');
    });
  
    // $("body").on('click','.wk-close-popup',function(){
    $("#wk_crowdsourcing_story").on('click','.wk-close-popup',function(){
      $(".wk-popup-main").remove();
    });
  
  
    $("body").on('click','.wk_read_more_title',function(){
      var more_title = $(this).parents('.wk_title').children('.wk_more_read_title').text();
      $(this).parent().html(more_title);
    });
  
    // $(".place_my_bid").on('click',function()
    $("body").unbind().on('click','.place_my_bid',function(){
      var placed_bid = $(this);
      $reward_err = false;
      $(".incremental-amt-err").siblings('input').css({ 'border-color':'#ccc' });
      $(".bid-amt-err").hide();
      var bid_amount = $(this).parents('tr').siblings('tr').find('input').val().trim();
      var minimum_bid_amount = $(this).siblings('.minimum_bid_amount').val();
      var id_option = $(this).siblings('.id_option').val();
      var id_project = $(this).siblings('.id_project').val();
      var minimum_incremental_amount = $(this).siblings('.minimum_incremental_amount').val();
      var main_id_customer = $("#wk_crowdsourcing").attr('customer_id');
      var customer_name = $("#wk_crowdsourcing").attr('customer_name');
      var customer_email = $("#wk_crowdsourcing").attr('customer_email');
      if(bid_amount.length < 1) {
        $(".incremental-amt-err").html("Enter the amount").show();
        $(".incremental-amt-err").siblings('input').css({ 'border-color':'red' });
        $reward_err = true;
      }
      // else if(parseInt(bid_amount) < parseInt(minimum_incremental_amount)) {
      //   $(".incremental-amt-err").html("Enter minimum incremental amount").show();
      //   $(".incremental-amt-err").siblings('input').css({ 'border-color':'red' });
      //   $reward_err = true;
      // }
    if (!main_id_customer) {
  var pageURL = $(location).attr("href");
  var handle = pageURL.substr(pageURL.indexOf("/products/") + 1);
  var loginUrl = (window.themeRoutes && window.themeRoutes.account_login_url) || "/account/login";
  window.location = loginUrl + "?checkout_url=" + encodeURIComponent("/" + handle);
  // $reward_err = true;
// }


        // $reward_err = true;
      }
      if(!$reward_err){
        $(".bid-amt-err").hide();
        $.ajax({
          type:"POST",
          url : CROWDSOURCING.api_url+"admin/Crowdsourcing",
          data:{bid_amount:bid_amount,id_option:id_option,id_project:id_project,main_id_customer:main_id_customer,customer_name:customer_name,customer_email:customer_email,shop_name:CROWDSOURCING.shop_name},
          jsonpCallback :"bidding",
          dataType: "jsonp",
          crossDomain: true,
          beforeSend: function() {
            $(".place_my_bid").addClass("cs-loader").prop("disabled",true);
            $(".place_my_bid").prop("disabled",true);
            $(".place_my_bid").css("opacity",'0.2');
          },
          complete: function() {
            $(".place_my_bid").removeClass("cs-loader").prop("disabled",false);
            $(".place_my_bid").prop("disabled",false);
            $(".place_my_bid").css("opacity",'1.0');
          },
          success:function(response)
          {
            // console.log(response);
            if(response){
              var  error = response.error;
              var error_topic =response.error_topic;
              if(!error){
                var bid_count =  placed_bid.parents('tr').siblings('tr').children('.bidding_right_td').children('.no_of_bids').children('span').html();
                bid_count = parseInt(bid_count) + 1;
                placed_bid.parents('tr').siblings('tr').children('.bidding_right_td').children('.no_of_bids').children('span').html(bid_count);
                var total_current_bid = placed_bid.parents('.bidding_details').siblings('.bid_wise_progress').children('.current_bid_amt').val();
                var original_currency = placed_bid.parents('.bidding_details').siblings('.bid_wise_progress').children('.original_currency').val();
                var updated_bid = parseFloat(total_current_bid) + parseFloat(bid_amount);
                placed_bid.parents('.bidding_details').siblings('.bid_wise_progress').children('.current_bid_amt').val(updated_bid);
                var funding_goal = placed_bid.parents('.bidding_details').siblings('.bid_wise_progress').children('.funding_goal').val();
                var pecentage = ((parseFloat(updated_bid) * 100)/parseFloat(funding_goal));
                percentage = parseFloat(pecentage).toFixed(2);
                var rest_pecentage = (100 - pecentage);
                rest_pecentage = parseFloat(rest_pecentage).toFixed(2);
                var wk_rest_amount_to_donate = placed_bid.siblings('.wk_rest_amount_to_donate').val();
                var wk_donated_amount = placed_bid.siblings('.wk_donated_amount').val();
  
                if(percentage > parseFloat(100)) {
                  placed_bid.parents('.bidding_details').siblings('.bid_wise_progress').children('.bid_wise_progress_bar').css({'width':'100%'});
                  placed_bid.parents('.bidding_details').siblings('.bid_wise_progress').children('.tooltiptext-rest').html(wk_rest_amount_to_donate + ' 0%');
                }else{
                  placed_bid.parents('.bidding_details').siblings('.bid_wise_progress').children('.bid_wise_progress_bar').css({'width':percentage+'%'});
                  placed_bid.parents('.bidding_details').siblings('.bid_wise_progress').children('.tooltiptext-rest').html(wk_rest_amount_to_donate + ' '+rest_pecentage+'%');
                }
                placed_bid.parents('.bidding_details').siblings('.wk_bid_detail_label').find('.donated_percentage').html(percentage+'%' + ' '+wk_donated_amount);
                placed_bid.parents('.bidding_details').siblings('.bid_wise_progress').children('.tooltiptext').html(wk_donated_amount + ' '+percentage+'%');
  
  
                updated_bid = original_currency + String(updated_bid);
                placed_bid.parents('tr').siblings('tr').children('.total_bid_right_td').html(updated_bid);
              }else{
                $(".incremental-amt-err").siblings('input').css({ 'border-color':'red' });
                $(".bid_placed").css({ 'color':'red !important' });
              }
              $(".bid_placed").css({ 'color':'#333 !important' });
              $(".bid_placed").html(error_topic).show();
            }else{
              $(".bid_placed").html('something went wrong').show();
            }
            setTimeout(function()
            {
              $('.bid_placed').css('display','none');
            }, 3000);
          }
        });
      }
    });
  
    $("body").on('click','.wk_reward_radio',function(){
      //$pledge_amount = $( ".donation_menu option:selected").val();
      $(".enter_donation_amt_err").siblings('label').children('input').css({ 'border-color':'#ccc' });
      $(".has_err").hide();
  
      $pledge_amount = $('input[name=rewards]:checked').val();
      main_id_variant = $(this).siblings('.main_id_variant').val();
      if(main_id_variant) {
  
        var permalink = "/cart/"+main_id_variant+":1?attributes[wk_permalink]=yes";
        $(this).parent().siblings('.wk_rewards_detail').find('.bidding_table').hide();
        // $(this).parent().siblings('.wk_rewards_detail').find('.bid_wise_progress').css({'margin': '0px'});
        // $(this).siblings('.bid_wise_progress').css({'margin':'-28px 0px 10px 30px'});
        $(this).parent().find('.bidding_table').show();
        $(".wk_donate_button").parent('.wk_anchor_btn').attr("href",permalink);
        $(".wk_anchor_btn").children(".wk_donate_button").attr("data-href",permalink);
        // $(".wk_donate_button").find("a").attr("href",permalink);
      }else{
        $(this).parent().siblings('.wk_rewards_detail').find('.bidding_table').hide();
        $(this).parent().find('.bidding_table').show();
        $('.wk_anchor_btn').removeAttr("href");
        $(".wk_donate_button").parent('.wk_anchor_btn').removeAttr("href");
      }
  
    });
  
    $('body').delegate('.input_donation_amount','click',function(){
      $(this).parents('.enter_donation_amount').siblings('.wk_rewards_detail').find('.wk_reward_radio').prop('checked',false);
      $(this).parents('.enter_donation_amount').children('.wk_reward_radio').prop('checked',true);
      $(this).parents('.enter_donation_amount').siblings('.wk_anchor_btn').removeAttr("href");
    });
  
  
    $('body').delegate('.wk_anchor_btn','click',function(e){
      var href = $(this).attr('href');
      $(".wk_anchor_btn").children('button').addClass("cs-loader").prop("disabled",true);
      if(!href) {
        $data_err = false;
        $(".enter_donation_amt_err").siblings('label').children('input').css({ 'border-color':'#ccc' });
        $(".has_err").hide();
  
        if($(this).siblings('.enter_donation_amount').length > 0) {
  
          var draft_amount = $(this).siblings('.enter_donation_amount').find('.input_donation_amount').val().trim();
          var customer_id= $("#wk_crowdsourcing").attr("customer_id");
          var customer_email = $("#wk_crowdsourcing").attr("customer_email");
          var default_variant_id = $("#wk_crowdsourcing").attr("variant_id");
          if ($('#wk_anonymous').is(':checked')) {
            var anonymous_user = 1;
          }else{
            var anonymous_user = 0;
          }
  
          if($(this).siblings('.wk_add_comments_div').children('.wk_add_comments').length > 0){
            var comment_details = $(this).siblings('.wk_add_comments_div').children('.wk_add_comments').val().trim();
            if(comment_details.length > 0) {
              comment_details = noscript(comment_details);
              if(comment_details.length > 500){
                var wk_comment_labels = $('.wk_comment_labels').val().trim();
                $(".wk_add_comment_err").html(wk_comment_labels).show();
                $(".wk_add_comment_err").css({ 'color':'red' });
                $data_err = true;
              }
            }
          }
          // if(!customer_id) {
          //   var pageURL = $(location).attr("href");
          //   var handle = pageURL.substr(pageURL.indexOf("/products/") + 1);
          //   window.location = '/account/login?checkout_url=/'+handle;
          // }
  
          var project_id = $(this).siblings('.project_id').val();
          if(draft_amount.length < 1) {
            var no_amt_er = $(this).siblings('.enter_donation_amount').children('.no_amount_err').val();
            $(".enter_donation_amt_err").html(no_amt_er).show();
            $(".enter_donation_amt_err").siblings('label').children('input').css({ 'border-color':'red' });
            $data_err = true;
            $(".wk_anchor_btn").children('button').removeClass("cs-loader").prop("disabled",false);
          }else if(draft_amount < 1) {
            var negative_amt_er = $(this).siblings('.enter_donation_amount').children('.negative_amount_err').val();
            $(".enter_donation_amt_err").html(negative_amt_er).show();
            $(".enter_donation_amt_err").siblings('label').children('input').css({ 'border-color':'red' });
            $data_err = true;
            $(".wk_anchor_btn").children('button').removeClass("cs-loader").prop("disabled",false);
          }
          if(!$data_err) {
            $.ajax({
              type:'POST',
              url : CROWDSOURCING.api_url+"admin/create_draft_order",
              jsonpCallback :"DRAFTORDER",
              dataType: "jsonp",
              crossDomain: true,
              data:{customer_id:customer_id,customer_email:customer_email,project_id:project_id,default_variant_id:default_variant_id,shop_name:CROWDSOURCING.shop_name,draft_amount:draft_amount,anonymous_user:anonymous_user,comment_details:comment_details},
              beforeSend: function() {
                $(".wk_anchor_btn").children('button').addClass("cs-loader").prop("disabled",true);
                $(".wk_anchor_btn").prop("disabled",true);
                $(".wk_anchor_btn").css("opacity",'0.2');
              },
              complete: function() {
                $(".wk_anchor_btn").children('button').removeClass("cs-loader").prop("disabled",false);
                $(".wk_anchor_btn").prop("disabled",false);
                $(".wk_anchor_btn").css("opacity",'1.0');
              },
              success:function(response){
                if(response){
                  // console.log(response);
                  window.location.href = response;
                }
              },
              error:function(response){
                console.log("something went wrong");
              }
            });
          }
        }
      }else{
        e.preventDefault();
        $data_err = false;
        if ($('#wk_anonymous').is(':checked')) {
          var anonymous_user = 1;
        }else{
          var anonymous_user = 0;
        }
  
        if($(this).siblings('.wk_add_comments_div').length > 0){
          if($(this).siblings('.wk_add_comments_div').children('.wk_add_comments').length > 0){
            var comment_details = $(this).siblings('.wk_add_comments_div').children('.wk_add_comments').val().trim();
            if(comment_details.length > 0) {
              comment_details = noscript(comment_details);
              if(comment_details.length > 500){
                $(".wk_add_comment_err").html('Comments character should be less than 500').show();
                $(".wk_add_comment_err").css({ 'color':'red' });
                $data_err = true;
              }
            }
          }
        }else{
          var comment_details = '';
          if(href.indexOf('?attributes[wk_permalink]=yes') == -1){
            href = href+'?attributes[wk_permalink]=yes';
          }
        }
        if(!$data_err) {
          var comments_attr = "&attributes[comments]="+comment_details;
          var anonymous_user_data = "&attributes[anonymous_user]="+anonymous_user;
          permalink = href+comments_attr+anonymous_user_data;
          $(".wk_anchor_btn").attr("href",permalink);
          location.href = permalink;
        }
      }
    });
  
  
    // $('.bid_wise_progress').hover(
    //   function(){
    //     if($(this).children(".bid_wise_progress_bar").width()) {
    //       var f = $(this).children(".bid_wise_progress_bar").width() / $(this).children('.bid_wise_progress_bar').parent().width() * 100;
    //       if(f >= 100) { $(this).children('.tooltiptext').css({'visibility':'visible'}) }else if(f > 0 && f < 100){ $(this).children('.tooltiptext-rest').css({'visibility':'visible'}); $(this).children('.tooltiptext').css({'visibility':'visible'}); }else if(f <= 0){ $(this).children('.tooltiptext-rest').css({'visibility':'visible'}); }
    //     }
    //   },
    //   function(){
    //     $(this).children('.tooltip-top').css({'visibility':'hidden'});
    //   }
    // );
  
    $(document).on('mouseenter','.bid_wise_progress', function (event) {
      // if($(this).children(".bid_wise_progress_bar").width()) {
        var f = $(this).children(".bid_wise_progress_bar").width() / $(this).children('.bid_wise_progress_bar').parent().width() * 100;
        if(f >= 100) { $(this).children('.tooltiptext').css({'visibility':'visible'}) }else if(f > 0 && f < 100){ $(this).children('.tooltiptext-rest').css({'visibility':'visible'}); $(this).children('.tooltiptext').css({'visibility':'visible'}); }else if(f <= 0){ $(this).children('.tooltiptext-rest').css({'visibility':'visible'}); }
      // }
    }).on('mouseleave','.bid_wise_progress',  function(){
      $(this).children('.tooltip-top').css({'visibility':'hidden'})
    });
  
    // $("body").on("click",".donation_story_btn",function(){
    //   $variant_id = $(this).next('input').val();
    //   //console.log($variant_id);
    //   if($variant_id){
    //     addToCart($variant_id);
    //   }
    // });
  
  
  
    $("body").on('click','.crowdfunding_record_li',function(){
      var record_no = $(this).text();
      if(record_no == '<') {
        var record_no = $(this).next('.crowdfunding_record_li').text();
      }
      else if(record_no == '>') {
        var record_no = $(this).prev('.crowdfunding_record_li').text();
      }
      var customer_id = $("#wk_bidding_detail").attr("customer_id");
      if(customer_id) {
        getBiddingDetail(0,customer_id,record_no,1,'winning_customer');
        // getBiddingDetail(0,customer_id,0,1,'winning_customer');
      }
    });
  
    $("body").on("click",".wk_view_record",function(){
      $offset = $("#reward_details").offset();
      $('html, body').animate({scrollTop: $('#reward_details').offset().top -100 }, 'slow');
    });
  
    $("body").on("click",".wk_latest_updates_tab",function(){
      var theme_color = $(this).siblings('.theme_color_input').css('background-color');
      var own_background_color = $(this).css('background-color');
      $(this).css('background-color', theme_color);
      $(this).siblings('.wk_tab').css('background-color', '#ccc');
      $(".wk_latest_update").show();
      $(".wk_crowdfunding_story").hide();
    });
  
    $("body").on("click",".wk_crowdfunding_story_tab",function(){
      var theme_color = $(this).siblings('.theme_color_input').css('background-color');
      var own_background_color = $(this).css('background-color');
      $(this).css('background-color', theme_color);
      $(this).siblings('.wk_tab').css('background-color', '#ccc');
      $(".wk_latest_update").hide();
      $(".wk_crowdfunding_story").show();
    });
    
  
  }).call(this);
  
  function noscript(strCode){
    var html = $(strCode.bold()); 
    html.find('script').remove();
    return html.html();
  }
  
  function addToCart($variant_id)
  {
    jQuery.post('/cart/clear.js');
    setTimeout(function(){
      jQuery.post('/cart/add.js', {
        quantity: 1,
        id: $variant_id,
      });
    },800);
    setTimeout(function(){
      window.open("/cart");
    },2400);
  }
  
  function getBiddingDetail(winning_auction,customer_id,offset,record_no,callback,search_project_title=false,search_option_title=false,search_status=false,bidding_search_amount=false) {
  
    // winning_auction for check this is all_bids or winning_bid tab. 1 means all bids and 0 means winning bids.
  
  
    if(!search_project_title) {
      search_project_title = '';
    }
    if(!search_option_title) {
      search_option_title = '';
    }
    if(!search_status) {
      search_status = '';
    }
    if(!bidding_search_amount) {
      bidding_search_amount = '';
    }
  
    var data = {main_id_customer:customer_id,offset:offset,record_no:record_no,shop_name:CROWDSOURCING.shop_name,search_project_title:search_project_title,search_option_title:search_option_title,search_status:search_status,bidding_search_amount:bidding_search_amount};
    $.ajax({
      type:'POST',
      url : CROWDSOURCING.api_url+"admin/crowdfunding_frontend",
      jsonpCallback :callback,
      dataType: "jsonp",
      crossDomain: true,
      data:data,
      beforeSend: function() {
        $(".front_loader").show();
      },
      success:function(response){
        // console.log(response);
        $("#wk_bidding_detail").html(response);
        if(winning_auction) {
          $(".all_bids").css({'border-bottom':'3px solid #f45b4f'});
          $(".winning_auction").css({'border-bottom':'none'});
        }else{
          $(".winning_auction").css({'border-bottom':'3px solid #f45b4f'});
          $(".all_bids").css({'border-bottom':'none'});
        }
      },
      complete:function() {
        $(".front_loader").hide();
      },
      error:function(response){
        console.log("something went wrong");
      }
    });
  }
  